import { Link } from 'react-router-dom'
import './InvolvedAudience.css'

function ForPrinciples() {
  return (
    <div className="audience-page">
      <div className="audience-panel">
        <h1 className="audience-title">For Principals</h1>
        <p className="audience-intro">
          Taha Wairua is a faith-based after-school partnership model that
          supports student wellbeing by creating safe spaces for belonging and
          optional, accessible spiritual-health practices.
        </p>

        <section className="audience-section">
          <h2>Why schools are engaging</h2>
          <ul className="audience-list">
            <li>
              Youth wellbeing trends show increasing anxiety, loneliness, and
              social pressure.
            </li>
            <li>
              Gen Z is open to spirituality, yet many students have limited
              access to trusted, guided practices.
            </li>
            <li>
              Regional research identifies demand for youth hubs and safe
              after-school environments.
            </li>
          </ul>
        </section>

        <section className="audience-section">
          <h2>What the program looks like</h2>
          <ul className="audience-list">
            <li>
              Whanaungatanga Time (3:15pm-4:15pm): drop-in hangout, kai, games,
              and intentional relationship-building.
            </li>
            <li>
              Wairua Time (4:30pm-5:15pm, opt-in): karakia and guided practices
              such as journaling, gratitude, contemplation, or breath prayers.
            </li>
            <li>
              Closing Time (5:15pm-5:30pm): karakia and student collection.
            </li>
          </ul>
        </section>

        <section className="audience-section">
          <h2>Partnership outcomes</h2>
          <p>
            The program helps schools offer supportive after-school care while
            strengthening community connection through local church partnership.
            It is designed to be inclusive, relational, and safe for students
            from diverse backgrounds.
          </p>
        </section>

        <section className="audience-section">
          <h2>Next steps</h2>
          <p>
            We would welcome a no-obligation conversation about whether this
            could support your school community. Please connect via the{' '}
            <Link to="/contact" className="audience-link">Contact</Link> page.
          </p>
        </section>
      </div>
    </div>
  )
}

export default ForPrinciples
